import styled from 'styled-components';

export const Wrapper = styled.div<{
  $flexDirection?: string;
  $mobileDirection?: string;
  $tabletDirection?: string;
}>`
  display: flex;
  flex-direction: ${(props) =>
    props.$flexDirection ? props.$flexDirection : 'column'};

  @media screen and (max-width: 768px) {
    flex-direction: ${(props) =>
      props.$tabletDirection ? props.$tabletDirection : 'column'};
  }

  @media screen and (max-width: 431px) {
    flex-direction: ${(props) =>
      props.$mobileDirection ? props.$mobileDirection : 'column'};
  }
`;

export const ImageWrapper = styled.div<{
  $aspectRatio: number;
  $width?: string;
  $mobileWidth?: string;
  $tabletWidth?: string;
  $maxWidth?: string;
  $maxLgWidth?: string;
}>`
  aspect-ratio: ${(props) => props.$aspectRatio};
  position: relative;
  width: ${(props) => props.$width};
  max-width: ${(props) => props.$maxWidth};
  overflow: hidden;

  @media screen and (max-width: 1024px) {
    max-width: ${(props) =>
      props.$maxLgWidth ? props.$maxLgWidth : props.$maxWidth};
  }

  @media screen and (max-width: 768px) {
    width: ${(props) => (props.$tabletWidth ? props.$tabletWidth : '100%')};
    max-width: unset;
  }

  @media screen and (max-width: 431px) {
    width: ${(props) => (props.$mobileWidth ? props.$mobileWidth : '100%')};
    max-width: unset;
  }
`;

export const ImageHoverWrapper = styled.div`
  transform: scale(1);
  transition: transform 0.3s ease-in-out;
  height: 100%;
  &:hover {
    transform: scale(1.1);
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.25rem;
  position: relative;
`;

export const ContentSkeletonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  width: 100%;
`;

export const TitleSkeletonWrapper = styled.div`
  min-height: 2.5rem;
`;

export const StyledDescription = styled.h4<{
  $whiteText?: boolean;
}>`
  font-size: 10px;
  font-weight: 400;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  color: ${(props) => (props.$whiteText ? '#FFF' : '#374255')};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  margin: 0;
  max-width: 100%;
  align-items: center;
  line-height: 11px;
  @media only screen and (min-width: 768px) {
    line-height: 14px;
    font-size: 13px;
  }
`;

export const StyledTitle = styled.p<{
  $whiteText?: boolean;
  $simpleMbView?: boolean;
  $isList?: boolean;
  $loading?: boolean;
}>`
  font-weight: 700;
  letter-spacing: 0em;
  text-align: left;
  color: ${(props) => (props.$whiteText ? '#FFF' : '#1E242F')};
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: ${(props) => (props.$loading ? 'unset' : 'vertical')};
  min-height: 2.5rem;
  font-size: 13px;
`;

export const StyledTitleTag = styled.p<{
  $whiteText?: boolean;
  $fontSize?: number;
}>`
  font-weight: 700;
  letter-spacing: 0em;
  text-align: left;
  color: ${(props) => (props.$whiteText ? '#FFF' : '#1E242F')};
  margin: 0;
  font-size: ${(props) => (props.$fontSize ? `${props.$fontSize}px` : '13px')};
  }
`;

export const FlashWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(to top left, transparent 50%, #ffc800 50%) 0 0/100%
    48px no-repeat;
  font-weight: bold;
  z-index: 1;
  width: 48px;
  height: 48px;
  padding: 0.5rem;
`;

export const RowWrapper = styled.div<{
  $backgroundColor?: string;
  $gap?: number;
  $padding?: string;
}>`
  border-radius: 66px;
  background-color: ${(props) =>
    props.$backgroundColor ? `${props.$backgroundColor}` : 'transparent'};
  padding: ${(props) => (props.$padding ? `${props.$padding}` : '0px')};
  flex-flow: row nowrap;
  gap: ${(props) => (props.$gap ? `${props.$gap}px` : '4px')};
  display: flex;
  align-items: center;

  @media only screen and (max-width: 528px) {
    margin-right: auto;
    gap: 4px;
  }
`;

export const ParentWrapper = styled.div<{
  $gap?: number;
  $padding?: string;
}>`
  padding: ${(props) => (props.$padding ? `${props.$padding}` : '0px')};
  row-gap: 4px;
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 528px) {
    align-items: center;
    column-gap: ${(props) => (props.$gap ? `${props.$gap}px` : '4px')};
    flex-direction: row;
  }
`;

export const Badge = styled.div`
  border-radius: 9999px;
  background: #374255;
  padding: 4px 6px;
  opacity: 0.3;
  &:hover {
    opacity: 1;
  }
`;

export const BadgeRow = styled.div`
  z-index: 2;
  right: 10px;
  top: 10px;
  position: absolute;
  gap: 10px;
  flex-flow: row nowrap;
  display: flex;
  align-items: center;
`;

export const UsedContainer = styled.div`
  padding: 4px;
  border-radius: 4px;
  background: #0c79be;
`;
